<template>
  <div class="player-list-page app-content"> 
    
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.player.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>
    
    <div class="app-content-create">
      <!-- Filter button -->
      <app-filter-button
        :active.sync="activeFilter"
      />
    </div>
    
    <!-- Filter form -->
    <app-player-list-filter
      :style="{ display: activeFilter ? 'initial' : 'none' }"
    />

    <!-- Page -->
    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.player.list.title"></app-i18n>
      </h1>

      <app-player-list-toolbar></app-player-list-toolbar>
      <app-player-list-table></app-player-list-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import PlayerListFilter from '@modules/player/components/player-list-filter.vue';
import PlayerListTable from '@modules/player/components/player-list-table.vue';
import PlayerListToolbar from '@modules/player/components/player-list-toolbar.vue';

export default {
  name: 'app-player-list-page',
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
      rows: 'player/list/rows',
    }),
  },
  data() {
    return {
      activeFilter: false
    }
  },
  components: {
    [PlayerListFilter.name]: PlayerListFilter,
    [PlayerListTable.name]: PlayerListTable,
    [PlayerListToolbar.name]: PlayerListToolbar,
  },
};
</script>

<style scoped>
/* .player-list-page .app-content-create .app-content-create-button--hidden{
  display: nonde;
} */
</style>
